import { render } from "./PreviewDialog.vue?vue&type=template&id=557735f7&scoped=true"
import script from "./PreviewDialog.vue?vue&type=script&lang=js"
export * from "./PreviewDialog.vue?vue&type=script&lang=js"

import "./PreviewDialog.vue?vue&type=style&index=0&id=557735f7&lang=scss&scoped=true"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557735f7"]])

export default __exports__